module.exports = __webpack_public_path__ + "static/media/  (52).2ebe8743.jpg";